import React from "react";
import { Icons } from "@learningblocks/exp-constants";

const { ChevronDownSolid: ChevronSolid } = Icons;

export function OpenIcon(props) {
  return <ChevronSolid className={props.className} />;
}

export function CloseIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: "rotate(180deg)",
      }}
    />
  );
}
